// Module
var code = "<div class=\"loading-view-area\" ng-if=\"!$ctrl.viewReady\">\r\n  <div class=\"sk-fold sk-center\">\r\n    <div class=\"sk-fold-cube\"></div>\r\n    <div class=\"sk-fold-cube\"></div>\r\n    <div class=\"sk-fold-cube\"></div>\r\n    <div class=\"sk-fold-cube\"></div>\r\n  </div>\r\n</div>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/kubernetes/components/view-loading/viewLoading.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;